// extracted by mini-css-extract-plugin
module.exports = {"overlayStyle":"ArtistPopover_overlayStyle__3zbgv"};